import React, { useState } from 'react';
import { makeStyles, Theme, createStyles, Grid, Card, CardActionArea } from '@material-ui/core';

import CharGrid from '../../../../Character/CharGrid'
import { SpriteDefine } from '../../../../Character/SpriteManager'
import CharDialog from '../../../../Character/CharDialog';
import  * as Lambda from "../../../../../Lambda";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        padding: 16,
        textAlign: "left",
    },
    container: {
        margin: "auto"
    },
    item: {
        position: "relative",
    },
    media: {
        height: 0,
        width: "100%",
        paddingTop: '56.25%', // 16:9
    },
  }),
);

interface Props {
    room: Lambda.RoomType | undefined
    sprite?: SpriteDefine | undefined
    size?: string
}

function GridView(props: Props) {

    const classes = useStyles()

    const [popup, setPopup] = useState<Lambda.MemberType | undefined>()


    return (
        <div className={classes.root} >
            <Grid 
                container 
                spacing={2}  
                className={classes.container}
                justify="flex-start"
                alignItems="flex-start"
            >
                { props.room?.members?.map(member=>(
                    <Grid item key={member.id} className={classes.item}>
                        <Card>
                            <CardActionArea
                                onClick={e=>member.join && setPopup(member)}
                            >
                                <CharGrid 
                                    sprite={props.sprite}
                                    size={props.size}
                                    member={member}
                                />
                            </CardActionArea>
                        </Card>
                    </Grid>
                )) }
            </Grid>
            <CharDialog 
                sprite={props.sprite} 
                member={popup} 
                open={popup !== undefined} 
                onClose={()=>setPopup(undefined)}
                />
        </div>
    )
}

export default GridView;